'use strict';

exports.__esModule = true;
exports.BaseMenuItem = undefined;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _menuItemContainer = require('../containers/menuItemContainer');

var _menuItemContainer2 = _interopRequireDefault(_menuItemContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var BaseMenuItem = _react2['default'].createClass({
  displayName: 'BaseMenuItem',

  getDefaultProps: function getDefaultProps() {
    return {
      onClick: _lodash.noop
    };
  },
  render: function render() {
    var _props = this.props,
        active = _props.active,
        children = _props.children,
        className = _props.className,
        disabled = _props.disabled;


    return _react2['default'].createElement(
      'li',
      {
        className: (0, _classnames2['default'])({
          'active': active,
          'disabled': disabled
        }, className) },
      _react2['default'].createElement(
        'a',
        { onClick: this._handleClick, role: 'button' },
        children
      )
    );
  },
  _handleClick: function _handleClick(e) {
    var _props2 = this.props,
        disabled = _props2.disabled,
        onClick = _props2.onClick;

    e.preventDefault();
    !disabled && onClick(e);
  }
});

var MenuItem = (0, _menuItemContainer2['default'])(BaseMenuItem);

exports.BaseMenuItem = BaseMenuItem;
exports['default'] = MenuItem;


//////////////////
// WEBPACK FOOTER
// ./~/ssc-refer/lib/refer/MenuItem.react.js
// module id = 316
// module chunks = 0